"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTAndCAcceptanceStatusTabSubject = createTAndCAcceptanceStatusTabSubject;
exports.createSystemCompareTabSubject = createSystemCompareTabSubject;
exports.createNevadaTestSubject = createNevadaTestSubject;
exports.createSystemSummaryTabSubject = createSystemSummaryTabSubject;
exports.createProjectSelectionTabSubject = createProjectSelectionTabSubject;
exports.createDataCenterWizardSubject = createDataCenterWizardSubject;
exports.createCreateNewPricingSubject = createCreateNewPricingSubject;
exports.createPricingEditorSubject = createPricingEditorSubject;
exports.createSystemManagerSubject = createSystemManagerSubject;
exports.createPricingManagerSubject = createPricingManagerSubject;
exports.createCoilProToolTabSubject = createCoilProToolTabSubject;
exports.createFanProToolTabSubject = createFanProToolTabSubject;
exports.createFanMotorProToolTabSubject = createFanMotorProToolTabSubject;
exports.createOilonToolTabSubject = createOilonToolTabSubject;
exports.createHumidityConversionTabSubject = createHumidityConversionTabSubject;
exports.createPsychrometricChartTabSubject = createPsychrometricChartTabSubject;
exports.createEffectiveClaimsTabSubject = createEffectiveClaimsTabSubject;
exports.createUsageStatisticsTabSubject = createUsageStatisticsTabSubject;
exports.createMlcUsageStatisticsTabSubject = createMlcUsageStatisticsTabSubject;
exports.createAdvancedProductSearchTabSubject = createAdvancedProductSearchTabSubject;
exports.createAirPowerToolTabSubject = createAirPowerToolTabSubject;
exports.createAirMixingToolTabSubject = createAirMixingToolTabSubject;
exports.createUnsupportedBrowserTabSubject = createUnsupportedBrowserTabSubject;
exports.createAmountProfileSettingsTabSubject = createAmountProfileSettingsTabSubject;
exports.createDefaultSettingTabSubject = createDefaultSettingTabSubject;
exports.createAboutTabSubject = createAboutTabSubject;
exports.createStartTabSubject = createStartTabSubject;
exports.createJohanTestSubject = createJohanTestSubject;
exports.createPropertiesSelectorExampleSubject = createPropertiesSelectorExampleSubject;
exports.createLabelsManagerSubject = createLabelsManagerSubject;
exports.createNewSystemWizardSubject = createNewSystemWizardSubject;
exports.createSystemEditorSubject = createSystemEditorSubject;
exports.createProductPricePreviewTabSubject = createProductPricePreviewTabSubject;
exports.createDebugTabSubject = createDebugTabSubject;
exports.createSystemTypeValidationTabSubject = createSystemTypeValidationTabSubject;
exports.createProductValidationTabSubject = createProductValidationTabSubject;
exports.createRotorProductValidationTabSubject = createRotorProductValidationTabSubject;
exports.createProductPropertySearchTabSubject = createProductPropertySearchTabSubject;
exports.createSystemTypePropertySearchTabSubjectt = createSystemTypePropertySearchTabSubjectt;
exports.createVariantListingTabSubjectt = createVariantListingTabSubjectt;
exports.createTranslationSearchTabSubject = createTranslationSearchTabSubject;
const Guid = __importStar(require("@genesys/shared/lib/guid"));
const moment_1 = __importDefault(require("moment"));
function createTAndCAcceptanceStatusTabSubject() {
    return {
        type: "TAndCAcceptanceStatusTabSubject"
    };
}
function createSystemCompareTabSubject() {
    return {
        type: "SystemCompareTabSubject"
    };
}
function createNevadaTestSubject() {
    return {
        type: "NevadaTabSubject"
    };
}
function createSystemSummaryTabSubject(systemIds) {
    return {
        type: "SystemSummary",
        systemIds: systemIds
    };
}
function createProjectSelectionTabSubject(systemIds) {
    return {
        type: "ProjectSelectionTabSubject",
        systemIds: systemIds
    };
}
function createDataCenterWizardSubject() {
    return {
        type: "DataCenterWizardSubject"
    };
}
function createCreateNewPricingSubject(systemId) {
    return {
        type: "CreateNewPricingSubject",
        systemId: systemId
    };
}
function createPricingEditorSubject(id) {
    return {
        type: "PricingEditorSubject",
        id: id
    };
}
function createSystemManagerSubject(searchKey, scope) {
    return {
        type: "SystemManagerSubject",
        searchKey: searchKey,
        scope: scope,
        time: (0, moment_1.default)().unix()
    };
}
function createPricingManagerSubject() {
    return {
        type: "PricingManagerSubject"
    };
}
function createCoilProToolTabSubject() {
    return {
        type: "CoilProToolTabSubject"
    };
}
function createFanProToolTabSubject() {
    return {
        type: "FanProToolTabSubject"
    };
}
function createFanMotorProToolTabSubject() {
    return {
        type: "FanMotorProToolTabSubject"
    };
}
function createOilonToolTabSubject() {
    return {
        type: "OilonToolTabSubject"
    };
}
function createHumidityConversionTabSubject() {
    return {
        type: "HumidityConversionTabSubject"
    };
}
function createPsychrometricChartTabSubject() {
    return {
        type: "PsychrometricChartTabSubject"
    };
}
function createEffectiveClaimsTabSubject() {
    return {
        type: "EffectiveClaimsTabSubject"
    };
}
function createUsageStatisticsTabSubject() {
    return {
        type: "UsageStatisticsTabSubject"
    };
}
function createMlcUsageStatisticsTabSubject() {
    return {
        type: "MlcUsageStatisticsTabSubject"
    };
}
function createAdvancedProductSearchTabSubject() {
    return {
        type: "AdvancedProductSearchTabSubject"
    };
}
function createAirPowerToolTabSubject() {
    return {
        type: "AirPowerToolTabSubject"
    };
}
function createAirMixingToolTabSubject() {
    return {
        type: "AirMixingToolTabSubject"
    };
}
function createUnsupportedBrowserTabSubject() {
    return {
        type: "UnsupportedBrowserTabSubject"
    };
}
function createAmountProfileSettingsTabSubject() {
    return {
        type: "AmountProfileSettingsTabSubject"
    };
}
function createDefaultSettingTabSubject() {
    return {
        type: "DefaultSettingsTabSubject"
    };
}
function createAboutTabSubject() {
    return {
        type: "AboutTabSubject"
    };
}
function createStartTabSubject() {
    return {
        type: "StartTabSubject"
    };
}
function createJohanTestSubject() {
    return {
        type: "JohanTestSubject"
    };
}
function createPropertiesSelectorExampleSubject() {
    return {
        type: "PropertiesSelectorExampleSubject"
    };
}
function createLabelsManagerSubject() {
    return {
        type: "LabelsManagerSubject"
    };
}
function createNewSystemWizardSubject(id) {
    return {
        type: "NewSystemWizardSubject",
        id: id || Guid.createGuid()
    };
}
function createSystemEditorSubject(id) {
    return {
        type: "SystemEditorSubject",
        id: id
    };
}
function createProductPricePreviewTabSubject() {
    return {
        type: "ProductPricePreviewTabSubject"
    };
}
function createDebugTabSubject() {
    return {
        type: "DebugTabSubject"
    };
}
function createSystemTypeValidationTabSubject() {
    return {
        type: "SystemTypeValidationTabSubject"
    };
}
function createProductValidationTabSubject() {
    return {
        type: "ProductValidationTabSubject"
    };
}
function createRotorProductValidationTabSubject() {
    return {
        type: "RotorProductValidationTabSubject"
    };
}
function createProductPropertySearchTabSubject() {
    return {
        type: "ProductPropertySearchTabSubject"
    };
}
function createSystemTypePropertySearchTabSubjectt() {
    return {
        type: "SystemTypePropertySearchTabSubject"
    };
}
function createVariantListingTabSubjectt() {
    return {
        type: "VariantListingTabSubject"
    };
}
function createTranslationSearchTabSubject() {
    return {
        type: "TranslationSearchTabSubject"
    };
}
//# sourceMappingURL=tab-subjects.js.map